import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TeamCollaboration = () => {
  const [teamMembers] = useState([
  {
    id: 1,
    name: "Sarah Johnson",
    email: "sarah@company.com",
    role: "HR Manager",
    avatar: "https://images.unsplash.com/photo-1734456611474-13245d164868",
    avatarAlt: "Professional headshot of woman with brown hair in business attire smiling at camera",
    status: "active",
    lastActive: new Date(Date.now() - 1800000),
    permissions: ["search", "unlock", "shortlist"]
  },
  {
    id: 2,
    name: "Michael Chen",
    email: "michael@company.com",
    role: "Tech Lead",
    avatar: "https://images.unsplash.com/photo-1637080423110-6736ee5705ed",
    avatarAlt: "Professional headshot of Asian man with glasses in dark suit jacket",
    status: "active",
    lastActive: new Date(Date.now() - 3600000),
    permissions: ["search", "shortlist"]
  },
  {
    id: 3,
    name: "Emma Wilson",
    email: "emma@company.com",
    role: "Recruiter",
    avatar: "https://images.unsplash.com/photo-1708127851232-d1a1bcbd5449",
    avatarAlt: "Professional headshot of blonde woman in white blouse smiling warmly",
    status: "offline",
    lastActive: new Date(Date.now() - 86400000),
    permissions: ["search", "unlock", "shortlist", "team"]
  }]
  );

  const [sharedShortlists] = useState([
  {
    id: 1,
    name: "Senior Developer Positions",
    candidates: 8,
    owner: "Sarah Johnson",
    collaborators: ["Michael Chen", "Emma Wilson"],
    lastUpdated: new Date(Date.now() - 3600000),
    notes: 3
  },
  {
    id: 2,
    name: "Frontend Team Expansion",
    candidates: 12,
    owner: "Michael Chen",
    collaborators: ["Sarah Johnson"],
    lastUpdated: new Date(Date.now() - 7200000),
    notes: 7
  },
  {
    id: 3,
    name: "Remote Specialists",
    candidates: 5,
    owner: "Emma Wilson",
    collaborators: ["Sarah Johnson", "Michael Chen"],
    lastUpdated: new Date(Date.now() - 86400000),
    notes: 2
  }]
  );

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (hours < 24) {
      return `${hours}h ago`;
    } else {
      return `${days}d ago`;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':return 'success';
      case 'offline':return 'muted-foreground';
      default:return 'muted-foreground';
    }
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Team Collaboration</h3>
        <Button variant="outline" size="sm" iconName="UserPlus" iconPosition="left">
          Invite Member
        </Button>
      </div>
      {/* Team Members */}
      <div className="mb-8">
        <h4 className="font-medium text-foreground mb-4">Team Members</h4>
        <div className="space-y-3">
          {teamMembers?.map((member) =>
          <div key={member?.id} className="flex items-center justify-between p-3 rounded-lg border border-border">
              <div className="flex items-center space-x-3">
                <div className="relative">
                  <img
                  src={member?.avatar}
                  alt={member?.avatarAlt}
                  className="h-10 w-10 rounded-full object-cover" />

                  <div className={`absolute -bottom-1 -right-1 h-3 w-3 rounded-full border-2 border-card bg-${getStatusColor(member?.status)}`} />
                </div>
                <div>
                  <p className="font-medium text-foreground">{member?.name}</p>
                  <p className="text-sm text-muted-foreground">{member?.role}</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="text-right">
                  <p className="text-xs text-muted-foreground">
                    Last active {formatTimeAgo(member?.lastActive)}
                  </p>
                  <div className="flex items-center space-x-1 mt-1">
                    {member?.permissions?.map((permission) =>
                  <span key={permission} className="px-2 py-1 text-xs bg-muted text-muted-foreground rounded">
                        {permission}
                      </span>
                  )}
                  </div>
                </div>
                
                <button className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors">
                  <Icon name="Settings" size={16} />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Shared Shortlists */}
      <div>
        <h4 className="font-medium text-foreground mb-4">Shared Shortlists</h4>
        <div className="space-y-3">
          {sharedShortlists?.map((shortlist) =>
          <div key={shortlist?.id} className="p-4 rounded-lg border border-border hover:border-primary/50 transition-colors">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h5 className="font-medium text-foreground">{shortlist?.name}</h5>
                  <p className="text-sm text-muted-foreground">
                    {shortlist?.candidates} candidates • {shortlist?.notes} notes
                  </p>
                </div>
                <Button variant="ghost" size="sm" iconName="ArrowRight" iconPosition="right">
                  View
                </Button>
              </div>
              
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center space-x-2">
                  <span className="text-muted-foreground">Owner:</span>
                  <span className="font-medium text-foreground">{shortlist?.owner}</span>
                </div>
                <span className="text-muted-foreground">
                  Updated {formatTimeAgo(shortlist?.lastUpdated)}
                </span>
              </div>
              
              {shortlist?.collaborators?.length > 0 &&
            <div className="flex items-center space-x-2 mt-2">
                  <span className="text-xs text-muted-foreground">Collaborators:</span>
                  <div className="flex items-center space-x-1">
                    {shortlist?.collaborators?.map((collaborator, index) =>
                <span key={index} className="px-2 py-1 text-xs bg-primary/10 text-primary rounded">
                        {collaborator?.split(' ')?.[0]}
                      </span>
                )}
                  </div>
                </div>
            }
            </div>
          )}
        </div>
      </div>
    </div>);

};

export default TeamCollaboration;